<span
  class="np-informer-trigger"
  [class.np-informer-trigger--open]="informerOpen"
  (click)="diff = 0; op.toggle($event)"
  pTooltip="Избранные"
  tooltipPosition="top"
  tooltipStyleClass="p-n-tooltip"
  [showDelay]="200"
  [life]="1000">
  <i class="pi pi-star p-text-secondary"></i>
</span>

<p-overlayPanel
  #op
  [style]="{ width: 'min(400px, calc(100vw - 24px))' }"
  styleClass="dropdown-overlay-panel informer-overlay-panel-v2"
  (onShow)="onInformerShow()"
  (onHide)="onInformerHide()">
  <ng-template pTemplate="">
    <div class="inf-v2">
      <div class="inf-v2-head">
        <div class="inf-v2-head__left">
          <span
            class="inf-v2-head__accent"
            aria-hidden="true"></span>
          <crm-button
            type="button"
            icon="pi pi-refresh"
            styleClass="p-button-rounded text-white p-button-text mx-1"
            (onClick)="queryParams.offset = 0; loadNotifications()"></crm-button>
          <p class="inf-v2-head__title">Избранное</p>
        </div>
      </div>

      <div
        class="inf-v2-scroll"
        (scroll)="onScrollEnd($any($event.target))">
        <div *ngIf="loading" class="inf-v2-loading-fill">
          <crm-spinner></crm-spinner>
        </div>
        <ng-container *ngIf="!loading">
          <ng-container *ngIf="(notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.PROJECT })?.length">
            <div class="inf-v2-section-head">
              <p>Задачи</p>
              <div>
                <a
                  class="flex align-items-center justify-content-between gap-2"
                  (click)="op.hide()"
                  routerLink="/project/list"
                  [queryParams]="{
                    onlyFavorites: true,
                    participantKind: ProjectKindEnum.ALL,
                    listStyle: 'flat'
                  }">
                  <i class="pi pi-window-maximize"></i>
                  Подробнее
                </a>
              </div>
            </div>
            <div
              *ngFor="let project of notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.PROJECT }"
              class="inf-v2-card">
              <div class="flex px-3 py-2 gap-2 justify-content-between align-items-center">
                <a
                  routerLink="/project/card/{{ project.id }}"
                  [class.font-bold]="project.status?.type === ProjectStatusTypeEnum.THEME"
                  [ngStyle]="{ color: project.status.color }"
                  [pTooltip]="project.status ? project.status.name : null"
                  tooltipPosition="right"
                  (click)="op.hide()">
                  {{ project.name }}
                </a>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="(notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.HD_TASK })?.length">
            <div class="inf-v2-section-head">
              <p>Заявки HelpDesk</p>
              <div>
                <a
                  class="flex align-items-center justify-content-between gap-2"
                  (click)="op.hide()"
                  routerLink="/helpdesk/task"
                  [queryParams]="
                    {
                      onlyFavorites: true,
                      finishDate: false
                    } | concatDateParams: 'year'
                  ">
                  <i class="pi pi-window-maximize"></i>
                  Подробнее
                </a>
              </div>
            </div>
            <crm-table
              *ngIf="notifications?.length"
              [values]="notifications | keyValueFilter: { type: FavoriteInformerTypeEnum.HD_TASK }"
              [columns]="[]"
              styleClass="p-datatable-sm">
              <ng-template
                #rowTemplate
                let-task="item">
                <tr>
                  <td>
                    <a
                      routerLink="/helpdesk/task/card/{{ hdPrefixService.getPrefixedNumber(task) }}"
                      [ngStyle]="{ color: task.status.color }"
                      [pTooltip]="task.status ? task.status.name : null"
                      (click)="op.hide()">
                      {{ hdPrefixService.getPrefixedNumber(task) }}
                    </a>
                  </td>
                  <td>
                    <a [routerLink]="task.client?.id ? ['/client/client/card/', task.client?.id] : null">
                      {{ task.client?.name || 'Неизвестно' }}
                    </a>
                  </td>
                  <td>
                    <p [innerHTML]="getText(task.description) | truncate: 20"></p>
                  </td>
                </tr>
              </ng-template>
            </crm-table>
          </ng-container>
          <div
            *ngIf="paginationLoading"
            class="text-center py-3">
            <p-progressSpinner
              [style]="{
                width: '50px',
                height: '50px'
              }"></p-progressSpinner>
          </div>

          <div
            *ngIf="!notifications?.length"
            class="inf-v2-empty">
            <crm-no-data [size]="NoDataSize"></crm-no-data>
            <h4 class="font-normal">Нет избранных</h4>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>
